<template>
    <div class="mdui-container mdui-text-left" id="main-content">
        <div class="timeline">
            <div class="entry">
                <div class="title">
                    <h3>2019-06-26</h3>
                    <p>里程碑</p>
                </div>
                <div class="body">
                    <p>迭代2.0版本</p>
                    <ul>
                        <li>使用Vue.js重构前端</li>
                        <li>升级php版本，重构php程序，提升性能</li>
                        <li>引入腾讯云COS对象存储保存图片</li>
                        <li><del>更换DigitalOcean服务器</del></li>
                    </ul>
                </div>
            </div>
            <div class="entry">
                <div class="title">
                    <h3>2018-06-xx</h3>
                    <p>诞生</p>
                </div>
                <div class="body">
                    <p>1.0版本</p>
                    <ul>
                        <li>网站上线</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "timelines",
        data(){
            return{
                title: "更新日志",
            }
        },
        beforeMount() {
            this.$emit("titleChanged", this.title);
        }
    }
</script>

<style scoped>
    body * {
        box-sizing: border-box;
    }

    .mdui-container{
        max-width: 800px;
    }

    .timeline {
        width: 100%;
        max-width: 800px;
        background: #fff;
        padding: 100px 50px;
        position: relative;
        box-shadow: 0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2);
    }
    .timeline:before {
        content: '';
        position: absolute;
        top: 0px;
        left: calc(33% + 15px);
        bottom: 0px;
        width: 4px;
        background: #ddd;
    }
    .timeline:after {
        content: "";
        display: table;
        clear: both;
    }

    .entry {
        clear: both;
        text-align: left;
        position: relative;
    }
    .entry .title {
        margin-bottom: .5em;
        float: left;
        width: 33%;
        padding-right: 30px;
        text-align: right;
        position: relative;
    }
    .entry .title:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border: 4px solid salmon;
        background-color: #fff;
        border-radius: 100%;
        top: 15%;
        right: -8px;
        z-index: 99;
    }
    .entry .title h3 {
        margin: 0;
        font-size: 120%;
    }
    .entry .title p {
        margin: 0;
        font-size: 100%;
    }
    .entry .body {
        margin: 0 0 3em;
        float: right;
        width: 66%;
        padding-left: 30px;
    }
    .entry .body p {
        line-height: 1.4em;
    }
    .entry .body p:first-child {
        margin-top: 0;
        font-weight: 400;
    }
    .entry .body ul {
        color: #aaa;
        padding-left: 0;
        list-style-type: none;
    }
    .entry .body ul li:before {
        content: "–";
        margin-right: .5em;
    }


</style>


// WEBPACK FOOTER //
// src/components/Timeline.vue